import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";
import classNames from "classnames";

import { Row, Col, RSelect, Button } from "../Component";
import {
  ACADEMIC_YEAR_OPTIONS,
  FACULTIES_ENUM,
  FACULTIES_ENUM_READABLE,
  STUDENT_STATUSES,
  STUDENT_READABLE_STATUSES,
} from "../../utilities/constants";

const STATUS_TAB_KEYS = [
  STUDENT_STATUSES.SUBMITTED_APPLICATION,
  STUDENT_STATUSES.DOCUMENT_VERIFICATION,
  STUDENT_STATUSES.APPLICATION_CONDITIONAL_OFFER,
  STUDENT_STATUSES.APPLICATION_UNCONDITIONAL_OFFER,
  STUDENT_STATUSES.TUITION_FEE_PAID,
  STUDENT_STATUSES.ENROLLED,
];

const STATUS_BUTTON_COLORS = {
  [STUDENT_STATUSES.SUBMITTED_APPLICATION]: "info",
  [STUDENT_STATUSES.DOCUMENT_VERIFICATION]: "danger",
  [STUDENT_STATUSES.APPLICATION_CONDITIONAL_OFFER]: "orange",
  [STUDENT_STATUSES.APPLICATION_UNCONDITIONAL_OFFER]: "purple",
  [STUDENT_STATUSES.TUITION_FEE_PAID]: "dark",
  [STUDENT_STATUSES.ENROLLED]: "success",
};

const STATUS_BUTTON_CUSTOM_HEX = {
  orange: "#ffa353",
  purple: "#816bff",
};

const StudentsPageFilters = ({
  academicYear,
  setAcademicYear,
  facultyType,
  setFacultyType,
  createdDateFrom,
  setCreatedDateFrom,
  createdDateTo,
  setCreatedDateTo,
  activeStatusTab,
  setActiveStatusTab,
  onClearAllFilters,
}) => {
  const { t } = useTranslation();

  const facultyOptions = useMemo(
    () =>
      Object.keys(FACULTIES_ENUM).map((key) => ({
        value: FACULTIES_ENUM[key],
        label:
          FACULTIES_ENUM_READABLE[FACULTIES_ENUM[key]] || FACULTIES_ENUM[key],
      })),
    []
  );

  return (
    <div className="card card-inner mb-3">
      <div className="card-body">
        <Row className="g-3 align-items-end">
          <Col md="3">
            <label className="form-label">Academic year</label>
            <RSelect
              placeholder="Select academic year"
              options={ACADEMIC_YEAR_OPTIONS}
              value={academicYear}
              onChange={setAcademicYear}
              isClearable
            />
          </Col>
          <Col md="3">
            <label className="form-label">Faculty type</label>
            <RSelect
              placeholder="Select faculty"
              options={facultyOptions}
              value={facultyType}
              onChange={setFacultyType}
              isClearable
            />
          </Col>
          <Col md="2">
            <label className="form-label">Created from</label>
            <input
              type="date"
              className="form-control"
              value={createdDateFrom}
              onChange={(e) => setCreatedDateFrom(e.target.value)}
            />
          </Col>
          <Col md="2">
            <label className="form-label">Created to</label>
            <input
              type="date"
              className="form-control"
              value={createdDateTo}
              onChange={(e) => setCreatedDateTo(e.target.value)}
            />
          </Col>
          {onClearAllFilters && (
            <Col md="1">
              <Button
                type="button"
                color="info"
                className="btn-icon"
                iconName="reload"
                aria-label="Clear filters"
                onClick={onClearAllFilters}
              />
            </Col>
          )}
        </Row>

        <div className="mt-3">
          <label className="form-label d-block mb-2">Status</label>
          <div className="d-flex flex-wrap g-2">
            {STATUS_TAB_KEYS.map((statusKey) => {
              const color = STATUS_BUTTON_COLORS[statusKey] || "secondary";
              const isActive = activeStatusTab === statusKey;
              const customBg = STATUS_BUTTON_CUSTOM_HEX[color];
              const style = {
                ...(customBg && {
                  backgroundColor: customBg,
                  borderColor: customBg,
                  color: "#fff",
                }),
                ...(!isActive && { opacity: 0.85 }),
              };
              return (
                <button
                  key={statusKey}
                  type="button"
                  className={classNames(
                    "btn btn-sm mr-1 mb-1",
                    !customBg && `btn-${color}`
                  )}
                  style={Object.keys(style).length ? style : undefined}
                  onClick={() =>
                    setActiveStatusTab((prev) =>
                      prev === statusKey ? null : statusKey
                    )
                  }
                >
                  {STUDENT_READABLE_STATUSES[statusKey] || statusKey}
                </button>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
};

export default StudentsPageFilters;
